import React, { useContext } from 'react';
import { RadioGroupState } from '@react-stately/radio';
import { RadioProps } from './Radio';

interface RadioGroupStateProps {
  state: RadioGroupState;
  size?: RadioProps['size'];
}

export const RadioGroupContext =
  React.createContext<RadioGroupStateProps | null>(null);

export function useRadioGroupContext(): RadioGroupStateProps {
  const context = useContext(RadioGroupContext);
  if (context) {
    return context;
  }
  throw new Error('Radio should be rendered inside a RadioGroup.');
}
